const table = () => {
    document.querySelectorAll('.content .table.is-mobile').forEach($table => {
		// Move fake thead (first row of tbody) to a newly created real thead element
		const $curThead = $table.querySelector('tbody tr') // First row
		const $newThead = document.createElement('thead');
		$table.prepend($newThead);
		$newThead.appendChild($curThead);

		// Set data-th on tbody td's
		const ths = [...$newThead.querySelectorAll('th')].map($th => $th.innerText);
		$table.querySelectorAll('tr').forEach($tr => {
			$tr.querySelectorAll('td').forEach(($td, index) => {
				$td.setAttribute('data-th', ths[index]);
			})
		})
	});
}

module.exports = table;
